legalTitles = {
    init: function () {
        if ($(".section-legal h2").length > 0) {
            var index = 1;

            $(".section-legal h2").each(function () {
                var $h2 = $(this);
                var num = ("0" + index).slice(-2);
                var originalText = $h2.text();
                $h2.html('<span class="num">' + num + '</span> ' + originalText);
                index++;
            });
        }
    }
};

$(document).ready(function () {
    legalTitles.init();
});